<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('PlatformSettings.executionItems')">
                    <el-input
                      size="mini"
                      v-model="formInline.title"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.operator')">
                    <el-input
                      size="mini"
                      v-model="formInline.username"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('DriverManagement.operatTime')">
                    <el-date-picker
                      v-model="formInline.updateTime"
                      type="datetimerange"
                      style="width: 380px !important"
                      size="mini"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator
                      :start-placeholder="$t('common.choseTime')"
                      end-placeholder
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{$t('common.btn.search')}}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del"
                      >{{$t('common.btn.cancel')}}</el-button
                    >
                  </el-form-item>
                </el-form>
              </div>
              <!-- <div class="rightAll-btn">
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_EDIT')"
                  type="text"
                  @click="editUser"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.edit')}}</el-button
                >
                <el-button
                v-if="isPrimaryKey('USERMANAGEMENT_DELETE')"
                  type="text"
                  @click="deleteUser"
                  :disabled="this.selected.length != 1"
                  >{{$t('common.btn.delete')}}</el-button
                >
                <el-button v-if="isPrimaryKey('USERMANAGEMENT_ADD')" type="text" @click="addUser">{{$t('common.btn.add')}}</el-button
                >
                <i-column
                  :listData="columns"
                  @changeSort="changeSort"
                  ref="listSet"
                ></i-column>
              </div> -->
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <!-- <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="loginName"
            :label="$t('Login.loginName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.loginName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="userName"
            :label="$t('PlatformSettings.userName')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.userName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="phone"
            :label="$t('PlatformSettings.phone')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.phone"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="email"
            :label="$t('PlatformSettings.email')+':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="expiryDate"
            :label="$t('PlatformSettings.expiryDate')+':'"
            :label-width="formLabelWidth"
          >
            <el-date-picker
              value-format="yyyy-MM-dd"
              type="date"
              :placeholder="$t('common.btn.choseDate')"
              v-model="form.expiryDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            prop="rolePower"
            :label="$t('common.btn.rolePower')+':'"
            :label-width="formLabelWidth"
          >
            <el-select
              size="small"
              v-model="form.rolePower"
              :placeholder="$t('common.form.rolePower')"
            >
              <el-option
                v-for="item in RoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="isShow"
            prop="roleData"
            :label="$t('common.btn.roleData')+':'"
            :label-width="formLabelWidth"
          >
            <el-button @click="getPower">{{$t('common.btn.click')}}</el-button>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{$t('common.btn.cancel')}}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        v-if="diaHidden"
        class="treeDialong"
        :title="$t('common.btn.roleData')"
        :visible.sync="dialogPowerVisible"
        width="520px"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div>
          <div>
            <el-input
              size="small"
              :placeholder="$t('common.filterTip')"
              v-model="filterText"
            >
            </el-input>
            <div style="height: 380px">
              <el-scrollbar>
                <el-tree
                  :data="data"
                  show-checkbox
                  ref="tree"
                  node-key="label"
                  :check-on-click-node="false"
                  :default-expanded-keys="keyList"
                  :default-checked-keys="keyList"
                  :filter-node-method="filterNode"
                  :props="defaultProps"
                  :check-strictly="true"
                  @check="handCheck"
                  @check-change="checkChange"
                >
                </el-tree>
              </el-scrollbar>
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="handleClose">{{$t('common.btn.cancel')}}</el-button
                >
            <el-button size="small" type="primary" @click="submit('form')"
              >{{$t('common.btn.confirm')}}</el-button>
          </span>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import OperationLog from "./OperationLog";
export default OperationLog;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
